/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { CartContext, UPSELL_PRODUCTS } from '../context.jsx';
import { CheckboxSwitcher } from './checkbox-switcher.jsx';

export const CartItemContainer = ({
  item,
  Component
}) => {
  const {
    toggleSubscription,
    updateItem,
    removeItem
  } = useContext(CartContext);
  const {
    customTitle,
    productTitle,
    flavor,
    subscriptionId,
    disablePurchaseType
  } = window.variantDataSelector.getData(item.variant_id);
  const discountPrice = (item?.selling_plan_allocation?.compare_at_price || 0) * item.quantity;
  const subscriptionImageSrc = window.variantDataSelector.getData(item.id)?.subscriptionImage;
  const imageSrc = window.variantDataSelector.getData(item.id)?.image;
  const isSubscribed = Boolean(item.properties._subscription_id);
  const isSubscriptionToggleVisible = Boolean(subscriptionId) && !disablePurchaseType;
  const image = isSubscribed ? subscriptionImageSrc : imageSrc;

  const handleSubscriptionToggle = async (isSubscription) => {
    await toggleSubscription({
      item,
      isSubscription
    });
  };

  const handleQuantityChange = async (quantity) => {
    await updateItem({
      quantity,
      key: item.key,
      variantId: item.variant_id,
      isSubscription: isSubscribed
    });
  };

  const handleIncreaseQuantity = async () => {
    await handleQuantityChange(item.quantity + 1);
  };

  const handleDecreaseQuantity = async () => {
    if (item.quantity > 1) {
      await handleQuantityChange(item.quantity - 1);
    }
  };

  const handleRemoveItem = async () => {
    await removeItem({
      key: item.key,
      variantId: item.variant_id
    });
  };

  const checkboxSwitcher = isSubscriptionToggleVisible
    ? (
      <CheckboxSwitcher
        isSubscribed={isSubscribed}
        onChange={handleSubscriptionToggle}
      />
    ) : undefined;

  const isQuantityDisabled = UPSELL_PRODUCTS.includes(item.variant_id);

  return (
    <Component
      checkboxSwitcher={checkboxSwitcher}
      discountPrice={discountPrice}
      finalPrice={item.final_line_price}
      flavor={flavor}
      image={image}
      itemQuantity={item.quantity}
      itemUrl={item.url}
      productTitle={customTitle || productTitle}
      variantTitle={item.variant_title}
      isQuantityDisabled={isQuantityDisabled}
      onDecreaseQuantity={handleDecreaseQuantity}
      onIncreaseQuantity={handleIncreaseQuantity}
      onRemoveItem={handleRemoveItem}
    />
  );
};
